/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";

type Props = {
  customerId: string,
  status: string,
  size?: any
}

export const CustomerStatusIcon = (props: Props) => {
  const { customerId, status, size = "medium" } = props
  const navigate = useNavigate()
  const statusParams = (status: string): { label: string, color: any } => {
    switch (status) {
      case "init":
        return { label: "入力依頼中", color: "default" }
      case "registed":
        return { label: "入力済み", color: "primary" }
      case "suspended":
        return { label: "停止中", color: "error" }
      case "active":
        return { label: "有効", color: "success" }
      default:
        return { label: "不明", color: "default" }
    }
  }
  const params = statusParams(status)
  return (
    <Box display="contents" justifyContent="center">
      <Chip label={params.label} color={params.color} size={size} onClick={() => navigate(`/admin/customers/${customerId}`)} />
    </Box>
  );
};
